import React, { useState, useEffect } from 'react';
import queryString from 'query-string';
import { Auth, Hub } from 'aws-amplify';
import { Navigate, useLocation , Outlet} from 'react-router-dom';
import { Logger } from 'aws-amplify';
import Loader from '../Loader/Loader';

const logger = new Logger('PrivateRoute');

const PrivateRoute = () => {
  const { code } = queryString.parse(window.location.search);
  const [isAuthenticated, setIsAuthenticated] = useState();
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated && location.pathname !== "/") {
      localStorage.setItem('url', location.pathname);
    }
  }, [isAuthenticated, location.pathname]);

  useEffect(() => {
    const listener = (data) => {
      if (code) {
        const { payload } = data;
        logger.info(`A new auth event has happened: ${payload.event}`);
        switch (payload.event) {
          case 'signOut':
            logger.info('Signed out');
            setIsAuthenticated(false);
            break;
          case 'signIn':
            logger.info('Logged in as:', payload.data.username);
            setIsAuthenticated(!!payload.data.username);
            break;
          default:
            logger.info('Unhandled event:', payload.event);
            break;
        }
      }
    };
    Hub.listen('auth', listener);
    return () => Hub.remove('auth', listener);
  }, [code]);

  useEffect(() => {
    if (!code) {
      Auth.currentAuthenticatedUser()
        .then(user => {
          setIsAuthenticated(!!user.username);
        })
        .catch(() => {
          setIsAuthenticated(false);
        });
    }
  }, [code]);

  useEffect(() => {
    if (isAuthenticated !== undefined) {
      setLoading(false);
    }
  }, [isAuthenticated]);
    return (
    <div data-testid="private-route">
      {(loading) ? (
        <Loader isBlocking={loading} />
      ) : isAuthenticated ? (
        <Outlet />
      ) : (
        <Navigate to="/signIn" />
      )}
    </div>
  );
};



export default PrivateRoute;

